<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Jadwal Pengiriman</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="grey lighten-3" class="pa-3">
					<v-list-item dense class="px-1">
						<div v-if="false">
							<v-tabs color="cyan darken-2" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 white--text mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2 white--text" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<div class="px-3">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Pemesanan" v-model="po_code.value" color="cyan darken-2"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="dateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(search_date)" label="Tanggal Pengiriman" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="cyan darken-2"></v-text-field>
									</template>
									<v-date-picker range :min="today" color="cyan darken-2" v-model="search_date"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="supplier_product_name" item-value="supplier_product_id" outlined dense hide-details v-model="product.value" :items="optionProduct" label="Produk" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="warehouse.value" :items="optionWarehouse" label="Warehouse Tujuan" color="cyan darken-2" item-color="cyan darken-2" no-data-text="Tidak ada data yang sesuai">
								</v-autocomplete>
							</v-col>
						</v-row>
					</div>
					<v-card-actions class="px-3">
						<v-spacer></v-spacer>
						<v-btn @click="resetFilter" outlined color="grey darken-1" class="text-capitalize" dark>Reset</v-btn>
						<v-btn @click="cari" depressed color="cyan darken-2" dark class="ml-2 text-capitalize">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table class="table-w-140" loading :headers="headers" :items="scheduleResults" hide-default-footer :options.sync="option" :server-items-length="schedulePagination.total_data" disable-pagination>
					<template v-slot:item.po_status_created_datetime="{ item }">
						<div> {{ item.po_status_created_datetime | tanggaljam }}</div>
					</template>
					<template v-slot:item.po_schedule_detail_date="{ item }">
						<div> {{ item.po_schedule_detail_date | tanggal }}</div>
					</template>
					<template v-slot:item.po_code="{ item }">
						<div @click="filterbyCode(item.po_code)"> {{ item.po_code }}</div>
					</template>
					<template v-slot:item.po_schedule_detail_quantity="{ item }">
						<div> {{ item.po_schedule_detail_quantity | toNumber}}</div>
					</template>
					<template v-slot:item.warehouse_name="{ item }">
						<div class="pt-2 pb-2">
							<div>{{ item.warehouse_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.warehouse_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.warehouse_address }}</span></div>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!schedulePagination">
							<loading-data-cyan></loading-data-cyan>
						</div>
						<div class="py-3" v-else>
							<not-found-cyan></not-found-cyan>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card class="mb-3" outlined v-for="schedule in scheduleResults" :key="schedule.po_schedule_detail_id">
					<v-list color="grey lighten-3" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Pemesanan {{ schedule.po_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm6 md2 class="pr-3">
									<div class="body-2 oppacity-75">Warehouse Tujuan</div>
									<div class="subtitle-2">{{ schedule.warehouse_name }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2 class="pr-3">
									<div class="body-2 oppacity-75">Kontak Warehouse</div>
									<div class="subtitle-2">{{ schedule.warehouse_mobilephone }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2 class="pr-3">
									<div class="body-2 oppacity-75">Tanggal Pemesanan</div>
									<div class="subtitle-2">{{ schedule.po_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2 class="pr-3">
									<div class="body-2 oppacity-75">Tanggal Pengiriman</div>
									<div class="subtitle-2">{{ schedule.po_schedule_detail_date | tanggal }}</div>
								</v-flex>
								<v-flex xs6 sm6 md4 class="pr-3">
									<div class="body-2 oppacity-75">Alamat Warehouse</div>
									<div class="subtitle-2">{{ addresText(schedule) }}</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div>
						<v-card tile elevation="0">
							<v-simple-table class="white-row">
								<template v-slot:default>
									<thead class="grey lighten-3">
										<tr>
											<th class="text-left" width="70%">Nama Produk</th>
											<th class="text-center">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in schedule.product_detail" :key="index">
											<td class="text-left">{{ product.supplier_product_name }}</td>
											<td class="text-center">{{ product.po_schedule_detail_quantity }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card>
					</div>
				</v-card>
				<v-card outlined v-if="scheduleResults.length < 1">
					<div class="py-3">
						<not-found-cyan></not-found-cyan>
					</div>
				</v-card>
			</div>
			<div class="pt-5" v-if="schedulePagination.total_page > 1 && scheduleResults.length > 0">
				<v-row>
					<v-col cols="10" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="schedulePagination.total_page" total-visible="7" circle class="d-flex justify-end" color="cyan darken-2"></v-pagination>
					</v-col>
					<v-col cols="2" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit" label="Item" color="cyan darken-2" item-color="cyan darken-4"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState} from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			cardDisplay: true,
			dropfilter: false,
			dialogDetail: false,
			loading: true,
			headers: [
			{ text: 'Tanggal Pemesanan', value: 'po_status_created_datetime', width: '15%'  },
			{ text: 'Tanggal Pengiriman', value: 'po_schedule_detail_date', width: '12%'  },
			{ text: 'Kode Pemesanan', value: 'po_code', width: '10%' },
			{ text: 'Produk', value: 'supplier_product_name', width: '20%' },
			{ text: 'Jumlah', value: 'po_schedule_detail_quantity', width: '10%' },
			{ text: 'Warehouse Tujuan', value: 'warehouse_name', width: '33%' },
			],
			page: 1,
			listLimit: [ '5', '10', '20', '50', '100' ],
			limit: '10',
			params: [],
			sortBy: 'po_schedule_detail_date',
			sortDir: 'DESC',
			dateCreate: false,
			po_code: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'po_code'
			},
			warehouse: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'warehouse_id'
			},
			product: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'supplier_product_id'
			},
			schedule_date: {
				value: '',
				comparison: 'bet',
				type: 'date',
				field: 'po_schedule_detail_date'
			},
			search_date: [],
			po_id: '',
		}
	},
	computed: {
		...mapState('schedulesSupplier', ['scheduleResults', 'schedulePagination', 'optionWarehouse', 'optionProduct']),
	},
	methods: {
		...mapActions('schedulesSupplier', ['getSchedules', 'getDetailSchedule', 'exportSchedules', 'getOptionWarehouse', 'getOptionProduct']),

		getData() {
			this.getSchedules().then(() => {
				this.getOptionProduct().then(() => {
					this.getOptionWarehouse().then(() => {
						this.loading = false
					})
				})
			})
		},
		addresText(warehouse_data) {
			var data = []
			if (warehouse_data) {
				if (warehouse_data.warehouse_address)
					data.push(warehouse_data.warehouse_address)
				if (warehouse_data.warehouse_subdistrict_name)
					data.push(warehouse_data.warehouse_subdistrict_name)
				if (warehouse_data.warehouse_city_name)
					data.push(warehouse_data.warehouse_city_name)
				if (warehouse_data.warehouse_province_name)
					data.push(warehouse_data.warehouse_province_name)
			}
			return data.join(', ')
		},
		filterbyCode(val) {
			this.po_code.value = val
			this.dropfilter = true
			this.page = 1
			this.cari()
		},
		exportData(){
			this.exportSchedules(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.po_code.value = ''
			this.product.value = ''
			this.warehouse.value = ''
			this.schedule_date.value = ''
			this.search_date = []
			this.page = 1
			this.getSchedules(this.queryString({limit:this.limit, page: this.page}))
		},
		changePage(page) {
			this.page = page
			this.getSchedules(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getSchedules(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		cari() {
			this.params = []
			if (this.po_code.value)
				this.params.push(this.po_code)
			if (this.warehouse.value)
				this.params.push(this.warehouse)
			if (this.product.value)
				this.params.push(this.product)
			if (this.schedule_date.value){
				if (this.schedule_date.value.length > 1) {
					this.schedule_date.value.sort()
					let date = this.schedule_date.value.join('::')
					this.schedule_date.value = date
				}
				this.params.push(this.schedule_date)
			}
			this.page = 1
			this.getSchedules(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Jadwal Pengiriman`);
		this.getData()
	},
	watch: {
		search_date(val) {
			this.schedule_date.value = val
		},
	}
};
</script>